import { apiRequest } from '@/core';
import { type ResetPasswordPayload } from '@/slices/user/types';

export const resetPasswordRequest = async (resetData: ResetPasswordPayload) =>
  apiRequest<void>({
    endpoint: 'reset-password',
    body: resetData,
  });
